export default "__VITE_ASSET__ce38d75c__"